/**
 * Represents different types of customer retention claims.
 */
export enum CustomerRetentionClaimTypeModel {
	/**
	 * Represents all claims.
	 */
	AllClaims = 1,
	/**
	 * Represents claims for specialty drugs.
	 */
	SpecialtyDrugs = 2,
	/**
	 * Represents claims for non-specialty drugs.
	 */
	NonSpecialtyDrugs = 3,
	/**
	 * Represents claims by WAC Value.
	 */
	WacValue = 4
}
